const { foundGroup, getTransformOrigin, StartAnimation } = require("../animations");


export const SVGAnimation = (time, groups) => {
    for (let group of groups) {
        setTimeout(() => {
            const groupElement = foundGroup(group.id);
            groupElement.forEach(element => {
                if (group.id === ".group_8") {
                    element.classList.add('on');
                } else if (!element.classList.contains('group_8')) {
                    element.classList.add('on');
                }
                getTransformOrigin(element);
                StartAnimation(element);   
            })
        }, time+=group.time);
    }
}